







































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import QrCode from './QrCode.vue';
import ClipboardBar from './ClipboardBar.vue'
import { DictionaryEntry, DictionaryCategories, dictionary } from '@/dictionary';

@Component({ components: { QrCode, ClipboardBar } })
export default class WordCardComponent extends Vue {

    @Prop({ required: true })
    private word!: DictionaryEntry;

    @Prop({ default: true })
    private isDialog!: boolean;

    @Ref()
    private clipboard!: ClipboardBar;

    @Ref()
    private audio!: HTMLAudioElement;

    private get categories() {
        return this.word.category.map(category => ({
            key: category,
            name: DictionaryCategories[category].name
        }));
    }

    private get similar() {
        const staticSimilar = this.word.similar || [];
        const staticSimilarWords: DictionaryEntry[] = (this.word.similar || []).map(id => dictionary.find(entry => entry.id === id)!);

        const similar: DictionaryEntry[] = dictionary
            .filter(entry => entry.id !== this.word.id)
            .filter(entry => !staticSimilar.includes(entry.id))
            .map(entry => ({
                ...entry,
                commonCategories: entry.category.filter(category => this.word.category.includes(category)).length
            }))
            .filter(entry => entry.commonCategories !== 0)
            .sort((a, b) => a.commonCategories - b.commonCategories)

        return [
            ...staticSimilarWords,
            ...similar
        ].slice(0, 6);
    }

    private async copy() {
        await this.clipboard.copy(this.word.chinese);
    }


}
